import { useQuery } from "@tanstack/react-query";
import React, { useContext, useState } from "react";
import { TypeAnimation } from "react-type-animation";
import { AuthContext } from "../../../../contexts/AuthProvider";
import Loading from "../../../Shared/Loading/Loading";
import BookingModal from "../../BookingModal/BookingModal";
import FeaturePhone from "./FeaturePhone";

const FeaturePhones = () => {
   const [phone, setPhone] = useState(null);

   const {
      data: products = [],
      isLoading,
      refetch,
   } = useQuery({
      queryKey: ["products"],
      queryFn: async () => {
         const res = await fetch("https://recycle-hut-server.vercel.app/products");
         const data = await res.json();
         return data;
      },
   });

   const featurePhones = products.filter(
      (product) => product.category === "Feature Phones"
   );
   refetch();

   const { user } = useContext(AuthContext);

   const { data: users = [] } = useQuery({
      queryKey: ["users"],
      queryFn: async () => {
         const res = await fetch("https://recycle-hut-server.vercel.app/users");
         const data = await res.json();
         return data;
      },
   });
   // console.log("All Users:", users);

   const currentUser = users.find((u) => u.email === user?.email);
   // console.log("Current User from all users:", currentUser);

   const buyers = users.filter((u) => u.role === "buyer");
   const currentBuyer = buyers.find((b) => b.email === user?.email);

   if (isLoading) {
      return <Loading></Loading>;
   }

   return (
      <div className="mb-[-25px] md:mb-[-5px]">
         <div
            className="w-[90%] md:w-[30%] shadow-md mx-auto p-3 mt-6 md:mt-10 rounded-lg uncommon"
            data-aos="fade-left"
            data-aos-duration="1500"
         >
            <div className="flex justify-center items-center gap-[6px]">
               <span className="text-[22px] md:text-2xl text-center text-sky-600 font-bold">
                  <TypeAnimation
                     sequence={[`Total Feature Phones`, 3000]}
                     speed={40}
                     cursor={false}
                     repeat={Infinity}
                  />
               </span>
               <span className="text-[22px] md:text-2xl text-center text-sky-600 font-bold">
                  ({featurePhones?.length})
               </span>
            </div>
         </div>

         <div className="grid grid-cols-1 gap-10 lg:gap-14 mt-10 mb-16">
            {featurePhones.map((featurePhone) => (
               <FeaturePhone
                  key={featurePhone._id}
                  featurePhone={featurePhone}
                  setPhone={setPhone}
                  currentUser={currentUser}
                  currentBuyer={currentBuyer}
               ></FeaturePhone>
            ))}
         </div>

         {phone && <BookingModal phone={phone} setPhone={setPhone}></BookingModal>}
      </div>
   );
};

export default FeaturePhones;
